var __dePOMME=(document.documentElement.lang||'').toLowerCase().indexOf('de')===0;
/* ============================================================
   POMME Sport — PDP interactions (nda-sportwear only)
   - FinCut-style inline pack picker (tiers + auto color combos + size) + Pack Builder for custom mixes
   - Free-gift color popup (gift bag has colors)
   - Size guide modal: chart (cm/inch + Intl/EU/US/UK), how-to-measure, find-my-size wizard
   Reads server-rendered JSON: #psp-pack-data and #psp-size-data.
   Mirror rule: we only ADD lines to the real cart (/cart/add.js); Shopify (Kite) computes all prices.
   ============================================================ */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function readJSON(id) { var el = document.getElementById(id); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }

  /* ---------- iOS-safe body scroll lock (overflow:hidden alone does NOT lock iOS Safari) ---------- */
  var _lockY = 0, _locks = 0;
  function lockScroll() { if (_locks++ > 0) return; _lockY = window.scrollY || window.pageYOffset || 0; var b = document.body.style; b.position = 'fixed'; b.top = (-_lockY) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%'; }
  function unlockScroll() { if (_locks > 0) _locks--; if (_locks > 0) return; var b = document.body.style; b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = ''; window.scrollTo(0, _lockY); }

  /* ---------- money formatting (learn from a server-rendered sample) ---------- */
  var MF = null;
  function learnMoney(sample) {
    if (!sample) { MF = { pre: '', suf: '', dec: '.', th: ',', d: 2 }; return; }
    var m = sample.match(/([^\d\s.,]+)?\s*([\d.,]+)\s*([^\d\s.,]+)?/);
    var sym = '', side = 'pre';
    if (m) { if (m[1]) { sym = m[1]; side = 'pre'; } else if (m[3]) { sym = m[3]; side = 'suf'; } }
    var num = m ? m[2] : '44.90';
    var dec = '.', th = ',';
    var lastDot = num.lastIndexOf('.'), lastComma = num.lastIndexOf(',');
    if (lastComma > lastDot) { dec = ','; th = '.'; } else { dec = '.'; th = ','; }
    var decimals = 2; var di = num.lastIndexOf(dec);
    if (di === -1) decimals = 0; else decimals = num.length - di - 1;
    MF = { sym: sym, side: side, dec: dec, th: th, d: decimals, gap: /\s/.test(sample) };
  }
  function money(cents) {
    if (!MF) learnMoney('€0.00');
    var n = (cents / 100);
    var fixed = n.toFixed(MF.d);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, MF.th);
    var body = parts.join(MF.dec);
    var sym = MF.sym || '';
    var gap = MF.gap ? ' ' : '';
    return MF.side === 'suf' ? (body + gap + sym) : (sym + gap + body);
  }

  /* ---------- cart add (mirror) ---------- */
  function addItems(items, cb) {
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) {
        // Un ajout refusé (422 : variante indisponible) ne doit PAS ouvrir le drawer
        // comme un succès — le panier n'a pas changé.
        if (!r.ok) { if (cb) cb(); return; }
        return r.json().then(function () {
          // Open + refresh the cart drawer EXACTLY like the rest of the site: the theme's
          // CartDrawer opens on 'ajaxProduct:added' and the POMME drawer re-renders on it.
          // Do NOT also click .js-drawer-open-cart — that header trigger TOGGLES the drawer,
          // so it would instantly re-close the drawer this event just opened (that was the
          // "adds to cart but never opens the drawer" bug on sportswear PDPs).
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          if (cb) cb();
        });
      })
      .catch(function () { if (cb) cb(); });
  }

  /* ---------- size reco (partagé wizard + pack builder) ----------
     Barème poids (kg) ancré sur les tailles du size chart : XS<52, S<60, M<72, L<83, XL>=83.
     Les seuils sont pris en FIN de liste quand il y a moins de tailles, donc un produit
     4 tailles (S-XL) garde exactement l'ancien barème 60/72/83. Fix : l'ancien code
     plafonnait à idx 2 puis sautait à la dernière taille -> le L (idx 3) n'était jamais
     recommandé sur les produits 5 tailles. Ajustements taille/fit inchangés. */
  function recoSizeIdx(sizes, w, h, fit) {
    var n = sizes.length;
    var TH = [52, 60, 72, 83];
    var cuts = TH.slice(Math.max(0, TH.length - (n - 1)));
    var idx = cuts.length;
    for (var i = 0; i < cuts.length; i++) { if (w < cuts[i]) { idx = i; break; } }
    if (idx > n - 1) idx = n - 1;
    if (h) { if (h >= 176 && idx < n - 1) idx++; if (h <= 160 && idx > 0) idx--; }
    if (fit === 'relaxed' && idx < n - 1) idx++;
    return idx;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var PACK = readJSON('psp-pack-data');
    var SIZE = readJSON('psp-size-data');
    if (PACK && PACK.moneySample) learnMoney(PACK.moneySample);

    /* ============ MORPHO selector (DOM-driven) ============ */
    $all('[data-psp-morpho]').forEach(function (root) {
      var tabs = $all('[data-psp-mtab]', root), msgs = $all('[data-psp-mmsg]', root);
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = t.getAttribute('data-psp-mtab');
          tabs.forEach(function (x) { x.classList.toggle('on', x === t); });
          msgs.forEach(function (m) { m.classList.toggle('on', m.getAttribute('data-psp-mmsg') === i); });
        });
      });
    });

    /* Modals are native <dialog> opened with showModal() → browser TOP LAYER. */

    /* ============ SIZE MODAL ============ */
    var mask = $('#psp-size-mask');
    if (mask) {
      window.pspOpenSize = function (tab) { sizeTab(tab || 'chart'); var wasOpen = mask.open; try { if (mask.showModal) { if (!mask.open) mask.showModal(); } else { mask.setAttribute('open', ''); } } catch (e) { mask.setAttribute('open', ''); } if (!wasOpen) lockScroll(); };
      function closeSize() { try { if (mask.close) mask.close(); else { mask.removeAttribute('open'); unlockScroll(); } } catch (e) { mask.removeAttribute('open'); unlockScroll(); } }
      mask.addEventListener('close', function () { unlockScroll(); });
      var xBtn = $('.psp-x', mask); if (xBtn) xBtn.onclick = closeSize;
      mask.addEventListener('click', function (e) { if (e.target === mask) closeSize(); });
      function sizeTab(t) { ['chart', 'measure', 'quiz'].forEach(function (x) { var tb = $('#psp-tab-' + x), pn = $('#psp-mp-' + x); if (tb) tb.classList.toggle('on', x === t); if (pn) pn.classList.toggle('on', x === t); }); if (t === 'quiz') wizShow(0); };
      $all('[data-psp-sizetab]', mask).forEach(function (b) { b.onclick = function () { sizeTab(b.getAttribute('data-psp-sizetab')); }; });

      /* chart toggles */
      var CHART = (SIZE && (SIZE.chart || SIZE)) || null;
      if (CHART && (CHART.rows || CHART.grid)) {
        var isBra = CHART.type === 'bra' && !!CHART.grid;
        var sys = 'us', unit = 'cm';
        function cv(range) {
          if (!range) return '—';
          if (unit === 'cm') return range + ' cm';
          var p = String(range).replace(/[–—]/g, '-').split('-'); if (p.length < 2) return range;
          return Math.round(parseFloat(p[0]) / 2.54) + '–' + Math.round(parseFloat(p[1]) / 2.54) + '"';
        }
        function renderChart() {
          var t = $('#psp-chart'); if (!t) return;
          var h;
          if (isBra) {
            var cups = CHART.cups || ['A', 'B', 'C', 'D'];
            var bands = (CHART.bands && CHART.bands[sys]) || (CHART.bands && CHART.bands.eu) || [];
            h = '<tr><th rowspan="2">' + (__dePOMME ? 'Unterbrustweite' : 'Band') + '</th><th class="psp-cuphead" colspan="' + cups.length + '">' + (__dePOMME ? 'Körbchen' : 'Cup') + '</th></tr>';
            h += '<tr>' + cups.map(function (c) { return '<th>' + c + '</th>'; }).join('') + '</tr>';
            CHART.grid.forEach(function (row, i) { h += '<tr><td>' + (bands[i] || '') + '</td>' + row.map(function (sz) { return '<td>' + sz + '</td>'; }).join('') + '</tr>'; });
          } else {
            var ma = (CHART.measures && CHART.measures[0]) || 'A', mb = (CHART.measures && CHART.measures[1]) || 'B';
            h = '<tr><th>' + (__dePOMME ? 'Größe' : 'Size') + '</th><th>' + ma + '</th><th>' + mb + '</th></tr>';
            (CHART.rows || []).forEach(function (r) { var conv = sys === 'fr' ? r.eu : r[sys]; var sc = r.intl + (conv ? ' <span class="psp-conv">' + conv + '</span>' : ''); h += '<tr><td>' + sc + '</td><td>' + cv(r.a) + '</td><td>' + cv(r.b) + '</td></tr>'; });
          }
          t.innerHTML = h;
        }
        $all('#psp-sys button').forEach(function (b) { b.onclick = function () { $all('#psp-sys button').forEach(function (x) { x.classList.remove('on'); }); b.classList.add('on'); sys = b.getAttribute('data-s'); renderChart(); }; });
        $all('#psp-unit button').forEach(function (b) { b.onclick = function () { $all('#psp-unit button').forEach(function (x) { x.classList.remove('on'); }); b.classList.add('on'); unit = b.getAttribute('data-u'); renderChart(); }; });
        renderChart();
      }

      /* find-my-size wizard */
      var SIZES = (SIZE && SIZE.sizes) || (PACK && PACK.sizes) || ['S', 'M', 'L', 'XL'];
      var wStep = 0, wFit = null, wCare = null, wSize = SIZES[0];
      function wizShow(s) { wStep = s; $all('#psp-mp-quiz .psp-wstep').forEach(function (e) { e.classList.toggle('on', +e.getAttribute('data-step') === s); }); $all('#psp-mp-quiz .psp-wiz__prog i').forEach(function (e, i) { e.classList.toggle('on', i <= s); }); }
      window.pspWizNext = function () { if (wStep === 0 && !$('#psp-wH').value) { $('#psp-wH').focus(); return; } if (wStep === 1 && !$('#psp-wW').value) { $('#psp-wW').focus(); return; } wizShow(wStep + 1); };
      window.pspWizBack = function () { if (wStep > 0) wizShow(wStep - 1); };
      $all('#psp-wFit button').forEach(function (b) { b.onclick = function () { wFit = b.getAttribute('data-v'); wizShow(3); }; });
      $all('#psp-wCare button').forEach(function (b) { b.onclick = function () { wCare = b.getAttribute('data-v'); computeWiz(); wizShow(4); }; });
      function recoIdx(w, h, fit) { return recoSizeIdx(SIZES, w, h, fit); }
      function computeWiz() {
        var w = parseFloat($('#psp-wW').value), h = parseFloat($('#psp-wH').value);
        wSize = SIZES[recoIdx(w, h, wFit)];
        var rs = $('#psp-wResSize'); if (rs) rs.textContent = wSize;
        var care = __dePOMME ? { opacity: "du wirst lieben, dass es 100% blickdicht ist — nie durchsichtig, auch nicht in der Hocke.", tummy: 'der ultrahohe Bund gibt dir sofort einen flachen Bauch.', lift: 'der Sculpt-Scrunch hebt und rundet deine Form ganz natürlich.', support: 'er gibt dir festen Halt, der nicht einschneidet.', all: 'er erfüllt einfach alles.' } : { opacity: "you'll love that it's 100% squat-proof — never see-through, even mid-squat.", tummy: 'the ultra-high band gives you that instant flat-tummy hold.', lift: 'the sculpt scrunch lifts and rounds your shape, naturally.', support: 'it gives you that no-dig, locked-in support.', all: 'it ticks every box.' };
        var fw = __dePOMME ? (wFit === 'relaxed' ? 'einer lockeren' : wFit === 'true' ? 'einer passgenauen' : 'einer sculpted') : (wFit === 'relaxed' ? 'a relaxed' : wFit === 'true' ? 'a true-to-size' : 'a sculpted');
        var note = $('#psp-wResNote'); if (note) note.innerHTML = __dePOMME ? ('Basierend auf deiner Größe &amp; deinem Gewicht und ' + fw + ' Passform. Und ' + (care[wCare] || '') + ' Zwischen zwei Größen ist die größere am bequemsten.') : ('Based on your height &amp; weight and ' + fw + ' fit. And ' + (care[wCare] || '') + ' Between two sizes, sizing up is comfiest.');
      }
      window.pspApplySize = function () {
        // apply the recommended size to the inline pack size row if present
        if (window.pspSetSize) window.pspSetSize(wSize);
        closeSize();
      };
    }

    /* ============ PACK: tiers + combos + size + add + builder + gift ============ */
    if (!PACK) return;
    var ladder = PACK.ladder || [{ min: 1, pct: 0 }, { min: 2, pct: 0, ship: 1 }, { min: 3, pct: 20, ship: 1 }, { min: 4, pct: 24, ship: 1, gift: 1 }, { min: 5, pct: 26, ship: 1, gift: 1 }, { min: 6, pct: 30, ship: 1, gift: 1 }];
    function disc(q) { var best = { pct: 0, ship: false, gift: false }; ladder.forEach(function (t) { if (q >= t.min) best = { pct: t.pct || 0, ship: !!t.ship, gift: !!t.gift }; }); return best; }
    function discLabel(d) { if (d.pct) return '−' + d.pct + '%' + (d.gift ? (__dePOMME ? ' + Gratis-Geschenk' : ' + free gift') : '') + (__dePOMME ? ' + Versand' : ' + shipping'); return d.ship ? (__dePOMME ? 'Kostenloser Versand freigeschaltet' : 'Free shipping unlocked') : ''; }
    var UNIT = PACK.unitCents || 0;
    /* ---- pricing mode: fixed totals (per-product metafield custom.pack_prices) vs % ladder ---- */
    var MODE = PACK.mode || 'percent';
    var FIXED = (MODE === 'fixed' && Array.isArray(PACK.fixedTotals) && PACK.fixedTotals.length) ? PACK.fixedTotals : null;
    if (!FIXED) MODE = 'percent';
    var GIFT_ON = PACK.giftEnable === true;
    /* builder hard cap: the merchant's discount engine (Kite) only covers stacked offers up to
       this quantity — adding past it is blocked with a "maximum reached" notice. 0 = unlimited. */
    var MAXQ = parseInt(PACK.maxItems, 10) || 0;
    function maxMsg() { return __dePOMME ? ('Maximum erreicht — ' + MAXQ + ' Artikel pro Pack') : ('Maximum reached — ' + MAXQ + ' items per pack'); }
    /* total cart price (cents) for a pack of q in fixed mode; null in % mode.
       q within configured tiers -> exact configured total.
       q above the tiers -> the offers STACK (Hugo 2026-07-06, no floor price anymore): the price
       is the CHEAPEST COMBINATION of configured pack prices (e.g. 8 = 5+3 -> pay 3+2 units,
       23 = 4x5+3 -> pay 14 units). Mirrors cumulative Buy-X-Get-Y deals on the Kite side;
       Kite is the source of truth at checkout, so any above-tier projection is cosmetic. */
    var STACKED = {};
    function fixedTotal(q) {
      if (!FIXED) return null;
      if (q <= 0) return 0;
      if (q <= FIXED.length) return FIXED[q - 1];
      if (!STACKED[q]) {
        for (var n = FIXED.length + 1; n <= q; n++) {
          if (STACKED[n]) continue;
          var best = Infinity;
          for (var k = 1; k <= FIXED.length; k++) {
            var rest = n - k;
            var restCost = rest <= FIXED.length ? FIXED[rest - 1] : STACKED[rest];
            var c = FIXED[k - 1] + restCost;
            if (c < best) best = c;
          }
          STACKED[n] = best;
        }
      }
      return STACKED[q];
    }
    /* fixed mode: number of literally-free items in a pack of q (q minus what the total buys at unit price).
       Integer >= 1 only when the configured totals encode a real "buy X get N free" — used for marks + perk copy. */
    function freeCount(q) {
      if (!FIXED || !UNIT) return 0;
      var f = q - fixedTotal(q) / UNIT;
      return (Math.abs(f - Math.round(f)) < 0.02 && Math.round(f) >= 1) ? Math.round(f) : 0;
    }
    /* fixed mode: rebuild the builder progress marks from the real price list (only literal deals shown).
       barMaxFx = the qty that completes the offer (last free-item tier) — the progress bar fills up to it. */
    var barMaxFx = 0;
    if (FIXED && UNIT > 0) {
      var marksEl = document.querySelector('.psp-marks');
      var mk = [(PACK.freeShipFrom || 2) + ' · ship'], lastFree = 0;
      for (var mq = 2; mq <= FIXED.length; mq++) {
        var fN = freeCount(mq);
        if (fN > lastFree) { lastFree = fN; barMaxFx = mq; mk.push(mq + ' · +' + fN + (__dePOMME ? ' gratis' : ' free')); }
      }
      if (mk.length > 4) mk = mk.slice(0, 4);
      if (marksEl) marksEl.innerHTML = mk.map(function (t) { return '<span>' + t + '</span>'; }).join('');
    }
    var maxMin = ladder.reduce(function (a, t) { return Math.max(a, t.min); }, 6);
    var giftFrom = (ladder.filter(function (t) { return t.gift; })[0] || {}).min || 4;
    var COLORS = PACK.colors || [];
    var SIZES2 = PACK.sizes || ['S', 'M', 'L', 'XL'];
    var GIFTC0 = PACK.giftColors || [];
    var GIFTC = GIFTC0.filter(function (g) { return g.available !== false; });
    if (!GIFTC.length) GIFTC = GIFTC0; /* fallback: if a market reports all gift colors unavailable, still offer them */
    /* If NOTHING reports available (e.g. a market/region false-negative or missing data), ignore availability
       entirely so the bundle never renders empty. Genuine single sold-outs are still respected when some stock exists. */
    var ANY_AVAIL = false;
    if (PACK.availability) { for (var _k in PACK.availability) { if (PACK.availability[_k] === true) { ANY_AVAIL = true; break; } } } else { ANY_AVAIL = true; }
    function avail(color, size) { if (!ANY_AVAIL) return true; if (!PACK.availability) return true; var k = color + '|' + size; return PACK.availability[k] !== false; }
    function availAny(size) { if (!PACK.availability) return true; for (var i = 0; i < COLORS.length; i++) { if (avail(COLORS[i].name, size)) return true; } return COLORS.length === 0; }
    function variantId(color, size) { if (!PACK.variantMap) return null; return PACK.variantMap[color + '|' + size] || null; }
    function firstAvailSize() { for (var i = 0; i < SIZES2.length; i++) { if (availAny(SIZES2[i])) return SIZES2[i]; } return SIZES2[0]; }
    /* drive the (hidden) native variant picker so the product gallery switches to the chosen color
       (same effect as the original Swatch King swatches) */
    function selectNativeColor(name) {
      if (!name) return;
      var radios = $all('input[type="radio"][name="Color"], input[type="radio"][name="color"], input[type="radio"][name="Couleur"], input[type="radio"][name="Colour"], input[type="radio"][name="Colore"]');
      var hit = null, target = String(name).trim().toLowerCase();
      for (var i = 0; i < radios.length; i++) { var v = (radios[i].value || radios[i].getAttribute('data-value') || '').trim().toLowerCase(); if (v === target) { hit = radios[i]; break; } }
      if (!hit) return;
      if (!hit.checked) hit.checked = true;
      try { hit.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
      try { hit.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
      try { hit.click(); } catch (e) {}
    }
    function rep(x, n) { var a = []; for (var i = 0; i < n; i++) a.push(x); return a; }
    function colorsForSize(size) { return COLORS.filter(function (c) { return avail(c.name, size); }); }
    function buildCombos(N, size) {
      var av = colorsForSize(size), list = [];
      if (N <= 1) { av.forEach(function (c) { list.push({ label: c.name, recipe: [c.name], imgs: [c] }); }); return list; }
      if (av.length >= 1) list.push({ label: N + '× ' + av[0].name, recipe: rep(av[0].name, N), imgs: [av[0]] });
      if (av.length >= 2) { var a = Math.ceil(N / 2), b = N - a; list.push({ label: a + ' ' + av[0].name + ' · ' + b + ' ' + av[1].name, recipe: rep(av[0].name, a).concat(rep(av[1].name, b)), imgs: [av[0], av[1]] }); list.push({ label: N + '× ' + av[1].name, recipe: rep(av[1].name, N), imgs: [av[1]] }); }
      return list;
    }

    /* state */
    var pkTier = PACK.defaultTier || 4;
    var pkSize = (PACK.defaultSize && availAny(PACK.defaultSize)) ? PACK.defaultSize : firstAvailSize();
    var pkCombo = 0;
    var pkGiftId = (GIFTC[0] && GIFTC[0].id) || PACK.giftVariantId || null;
    var pkGiftCName = (GIFTC[0] && GIFTC[0].name) || '';
    var pkGiftAsked = false;
    var pendingGiftThen = null; /* set when the inline Add opens the gift popup → runs after the gift color is confirmed (no 2nd Add click) */

    var combosEl = $('#psp-combos'), sizesEl2 = $('#psp-isizes'), addBtn = $('#psp-add'), pickEl = $('#psp-combo-pick'), giftLine = $('#psp-giftline');
    function curCombos() { return buildCombos(pkTier, pkSize); }

    function esc(x) { return String(x == null ? '' : x).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

    function renderTiers() { $all('[data-psp-tier]').forEach(function (x) { var on = parseInt(x.getAttribute('data-psp-tier'), 10) === pkTier; x.classList.toggle('on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); }); }
    function renderCombos() {
      if (!combosEl) return;
      var cs = curCombos(); if (pkCombo >= cs.length) pkCombo = 0;
      var labEl = $('#psp-combo-lab');
      if (pkTier <= 1) {
        /* single unit: compact color swatches (no images, no "choose your pack", no create-palette) */
        if (labEl) labEl.textContent = (__dePOMME ? 'Farbe wählen' : 'Choose your color');
        combosEl.className = 'psp-combos psp-combos--sw';
        combosEl.innerHTML = cs.map(function (c, i) {
          var im = c.imgs[0] || {};
          return '<button type="button" class="psp-swatch' + (i === pkCombo ? ' on' : '') + '" data-psp-combo="' + i + '"><span class="sw-dot"><img loading="lazy" src="' + esc(im.img) + '" alt="' + esc(c.label) + '"></span><span class="sw-nm">' + esc(c.label) + '</span></button>';
        }).join('');
      } else {
        if (labEl) labEl.textContent = (__dePOMME ? 'Set wählen' : 'Choose your pack');
        combosEl.className = 'psp-combos';
        var html = cs.map(function (c, i) {
          var segs = c.imgs.map(function (im) { return '<span class="seg"><img loading="lazy" src="' + esc(im.img) + '" alt="' + esc(im.name) + '"></span>'; }).join('');
          return '<button type="button" class="psp-cb' + (i === pkCombo ? ' on' : '') + '" data-psp-combo="' + i + '"><span class="ph">' + segs + '</span><span class="t">' + esc(c.label) + '</span></button>';
        }).join('');
        html += '<button type="button" class="psp-cb psp-cb--make" data-psp-compose><span class="ic">+</span><span class="t">' + (__dePOMME ? 'Palette<br>erstellen' : 'Create your<br>palette') + '</span></button>';
        combosEl.innerHTML = html;
      }
      if (pickEl) pickEl.textContent = cs.length && cs[pkCombo] ? cs[pkCombo].label : '';
      $all('[data-psp-combo]', combosEl).forEach(function (b) { b.onclick = function () { pkCombo = parseInt(b.getAttribute('data-psp-combo'), 10); var cc = curCombos()[pkCombo]; renderCombos(); renderAdd(); if (cc && cc.imgs && cc.imgs[0]) selectNativeColor(cc.imgs[0].name); }; });
      $all('[data-psp-compose]', combosEl).forEach(function (b) { b.onclick = openPB; });
    }
    function renderSizes() {
      if (!sizesEl2) return;
      var html = '';
      SIZES2.forEach(function (sz) { var dis = !availAny(sz); html += '<button type="button" class="psp-isz' + (sz === pkSize ? ' on' : '') + '"' + (dis ? ' disabled' : '') + ' data-psp-isize="' + esc(sz) + '">' + esc(sz) + '</button>'; });
      sizesEl2.innerHTML = html;
      $all('[data-psp-isize]', sizesEl2).forEach(function (b) { b.onclick = function () { if (b.disabled) return; var prevLabel = (curCombos()[pkCombo] || {}).label; pkSize = b.getAttribute('data-psp-isize'); var nc = curCombos(), keep = -1; if (prevLabel != null) { for (var i = 0; i < nc.length; i++) { if (nc[i].label === prevLabel) { keep = i; break; } } } pkCombo = keep >= 0 ? keep : 0; renderSizes(); renderCombos(); renderAdd(); }; });
    }
    window.pspSetSize = function (sz) { if (SIZES2.indexOf(sz) >= 0 && availAny(sz)) { pkSize = sz; renderSizes(); renderCombos(); renderAdd(); } };
    function renderGiftLine() {
      if (!giftLine) return;
      if (GIFT_ON && pkTier >= giftFrom && GIFTC.length) {
        giftLine.style.display = '';
        giftLine.innerHTML = '🎁 <b>' + esc(PACK.giftName || (__dePOMME ? 'Gratis-Geschenk' : 'Free gift')) + '</b> — ' + (pkGiftCName ? ((__dePOMME ? 'Farbe: ' : 'color: ') + esc(pkGiftCName) + ' ') : '') + '<a data-psp-giftchange>' + (pkGiftCName ? (__dePOMME ? 'ändern' : 'change') : (__dePOMME ? 'Farbe wählen' : 'pick color')) + '</a>';
        var a = $('[data-psp-giftchange]', giftLine); if (a) a.onclick = openGift;
      } else { giftLine.style.display = 'none'; giftLine.innerHTML = ''; }
    }
    function renderAdd() {
      if (!addBtn) return;
      var was = UNIT * pkTier, total, showWas;
      if (MODE === 'fixed') { total = fixedTotal(pkTier); showWas = total < was; }
      else { var d = disc(pkTier); total = Math.round(UNIT * pkTier * (1 - d.pct / 100)); showWas = !!d.pct; }
      if (pkTier <= 1) addBtn.innerHTML = (__dePOMME ? 'In den Warenkorb' : 'Add to cart') + '<span class="atc-price">' + money(MODE === 'fixed' ? fixedTotal(1) : UNIT) + '</span>';
      else addBtn.innerHTML = (__dePOMME ? 'In den Warenkorb' : 'Add to cart') + '<span class="atc-price">' + money(total) + (showWas ? ' <s>' + money(was) + '</s>' : '') + '</span>';
      renderGiftLine();
    }

    $all('[data-psp-tier]').forEach(function (c) {
      c.onclick = function () { pkTier = parseInt(c.getAttribute('data-psp-tier'), 10); pkCombo = 0; renderTiers(); renderCombos(); renderSizes(); renderAdd(); };
      c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); c.click(); } });
    });
    $all('[data-psp-compose]').forEach(function (b) { if (!combosEl || !combosEl.contains(b)) b.onclick = openPB; });

    /* gift popup */
    var giftMask = $('#psp-giftpop'), gcEl = $('#psp-gcolors');
    function renderGiftColors() {
      if (!gcEl) return;
      gcEl.innerHTML = GIFTC.map(function (g) { return '<button type="button" class="psp-gc' + (String(g.id) === String(pkGiftId) ? ' on' : '') + '" data-gid="' + esc(g.id) + '" data-gname="' + esc(g.name) + '">' + (g.img ? '<img loading="lazy" src="' + esc(g.img) + '" alt="' + esc(g.name) + '">' : '') + '<span class="n">' + esc(g.name) + '</span></button>'; }).join('');
      $all('.psp-gc', gcEl).forEach(function (b) { b.onclick = function () { pkGiftId = b.getAttribute('data-gid'); pkGiftCName = b.getAttribute('data-gname'); pkGiftAsked = true; renderGiftColors(); renderGiftLine(); }; });
    }
    function openGift() { if (!GIFT_ON || !giftMask || !GIFTC.length) return; renderGiftColors(); var w = giftMask.open; try { if (giftMask.showModal) { if (!giftMask.open) giftMask.showModal(); } else giftMask.setAttribute('open', ''); } catch (e) { giftMask.setAttribute('open', ''); } if (!w) lockScroll(); }
    function closeGift() { try { if (giftMask.close) giftMask.close(); else { giftMask.removeAttribute('open'); unlockScroll(); } } catch (e) { giftMask.removeAttribute('open'); unlockScroll(); } }
    if (giftMask) { giftMask.addEventListener('close', function () { unlockScroll(); pendingGiftThen = null; }); giftMask.addEventListener('click', function (e) { if (e.target === giftMask) closeGift(); }); var gd = $('#psp-gdone'); if (gd) gd.onclick = function () { var f = pendingGiftThen; pendingGiftThen = null; closeGift(); if (f) f(); }; }
    function maybeGift() { if (GIFT_ON && pkTier >= giftFrom && GIFTC.length && !pkGiftAsked) { pkGiftAsked = true; openGift(); } }

    /* build the cart line items from a recipe (array of color names) at a size */
    function itemsFromRecipe(recipe, size, tagPack) {
      var byColor = {}; recipe.forEach(function (cn) { byColor[cn] = (byColor[cn] || 0) + 1; });
      var items = [], ok = true;
      for (var cn in byColor) { var v = variantId(cn, size); if (!v) { ok = false; break; } items.push({ id: v, quantity: byColor[cn], properties: tagPack ? { _pack: '1' } : {} }); }
      return ok ? items : null;
    }
    /* append the free gift line (deduped) then add everything in one POST */
    function addWithGift(items, qty, onDone) {
      var needGift = GIFT_ON && qty >= giftFrom && pkGiftId && GIFTC.length;
      function finish() { addItems(items, onDone); }
      if (needGift) {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          var giftIds = GIFTC.map(function (g) { return String(g.id); });
          var has = (cart.items || []).some(function (it) { return giftIds.indexOf(String(it.variant_id)) >= 0; });
          if (!has) items.push({ id: pkGiftId, quantity: 1, properties: { _gift: (PACK.giftName || (__dePOMME ? 'Geschenk' : 'Gift')) + (pkGiftCName ? ' — ' + pkGiftCName : '') } });
          finish();
        }).catch(function () { items.push({ id: pkGiftId, quantity: 1, properties: { _gift: (PACK.giftName || (__dePOMME ? 'Geschenk' : 'Gift')) } }); finish(); });
      } else finish();
    }

    /* inline add (quick path) */
    if (addBtn) addBtn.onclick = function () {
      var cs = curCombos(), combo = cs[pkCombo];
      if (!combo) return;
      var items = itemsFromRecipe(combo.recipe, pkSize, pkTier > 1);
      if (!items || !items.length) return;
      function doAdd() {
        addBtn.disabled = true; var prev = addBtn.innerHTML; addBtn.textContent = (__dePOMME ? 'Wird hinzugefügt…' : 'Adding…');
        addWithGift(items, pkTier, function () { addBtn.disabled = false; addBtn.innerHTML = prev; });
      }
      /* gift-eligible pack: ask the gift color once, then add automatically when she confirms (no 2nd Add click) */
      if (GIFT_ON && pkTier >= giftFrom && GIFTC.length && !pkGiftAsked) { pkGiftAsked = true; pendingGiftThen = doAdd; openGift(); return; }
      doAdd();
    };

    /* ---- Pack Builder (Compose / Create palette) ---- */
    var pbMask = $('#psp-pbmask');
    var pbSel = {}, pbSize = pkSize, pbFit = 'sculpt';
    function openPB() {
      if (!pbMask) return;
      pbSel = {}; pbSize = (PACK.defaultSize && availAny(PACK.defaultSize)) ? PACK.defaultSize : firstAvailSize();
      $('#psp-pb-step1').classList.add('on'); $('#psp-pb-step2').classList.remove('on');
      $('#psp-pb-recap').style.display = 'none'; $('#psp-pb-back').textContent = (__dePOMME ? '‹ Schließen' : '‹ Close');
      var f = $('#psp-pb-finder'); if (f) f.classList.remove('show');
      $all('#psp-pb-sizes button').forEach(function (b) { b.classList.toggle('on', b.textContent === pbSize); });
      var pbWasOpen = pbMask.open; try { if (pbMask.showModal) { if (!pbMask.open) pbMask.showModal(); } else { pbMask.setAttribute('open', ''); } } catch (e) { pbMask.setAttribute('open', ''); } if (!pbWasOpen) lockScroll();
    }
    function closePB() { try { if (pbMask.close) pbMask.close(); else { pbMask.removeAttribute('open'); unlockScroll(); } } catch (e) { pbMask.removeAttribute('open'); unlockScroll(); } }
    if (pbMask) {
      pbMask.addEventListener('close', function () { unlockScroll(); });
      pbMask.addEventListener('click', function (e) { if (e.target === pbMask) closePB(); });
      $('#psp-pb-back').onclick = function () {
        if ($('#psp-pb-step2').classList.contains('on')) { $('#psp-pb-step2').classList.remove('on'); $('#psp-pb-step1').classList.add('on'); $('#psp-pb-recap').style.display = 'none'; $('#psp-pb-back').textContent = (__dePOMME ? '‹ Schließen' : '‹ Close'); }
        else closePB();
      };
      var sizesEl = $('#psp-pb-sizes');
      if (!availAny(pbSize)) pbSize = firstAvailSize();
      SIZES2.forEach(function (s) { var b = document.createElement('button'); b.textContent = s; if (s === pbSize) b.className = 'on'; if (!availAny(s)) { b.disabled = true; b.title = (__dePOMME ? 'Ausverkauft' : 'Sold out'); } b.onclick = function () { if (b.disabled) return; pbSize = s; $all('#psp-pb-sizes button').forEach(function (x) { x.classList.toggle('on', x.textContent === s); }); }; sizesEl.appendChild(b); });
      var fl = $('#psp-pb-finderlink'); if (fl) fl.onclick = function () { $('#psp-pb-finder').classList.toggle('show'); };
      $all('#psp-pb-fit button').forEach(function (b) { b.onclick = function () { pbFit = b.getAttribute('data-v'); $all('#psp-pb-fit button').forEach(function (x) { x.classList.remove('on'); }); b.classList.add('on'); }; });
      var calc = $('#psp-pb-calc'); if (calc) calc.onclick = function () {
        var w = parseFloat($('#psp-pb-W').value), h = parseFloat($('#psp-pb-H').value); if (!w) { $('#psp-pb-W').focus(); return; }
        var idx = recoSizeIdx(SIZES2, w, h, pbFit);
        pbSize = SIZES2[idx]; $all('#psp-pb-sizes button').forEach(function (x) { x.classList.toggle('on', x.textContent === pbSize); });
        $('#psp-pb-finderres').innerHTML = __dePOMME ? ('Wir empfehlen <b>Größe ' + pbSize + '</b> — ausgewählt. Eine Größe größer für mehr Platz.') : ('We recommend <b>size ' + pbSize + '</b> — selected. Size up for more room.');
      };
      $('#psp-pb-use').onclick = function () { $('#psp-pb-step1').classList.remove('on'); $('#psp-pb-step2').classList.add('on'); $('#psp-pb-recap').style.display = 'block'; $('#psp-pb-back').textContent = (__dePOMME ? '‹ Zurück' : '‹ Back'); $('#psp-pb-sizelabel').textContent = pbSize; renderColors(); renderRecap(); };

      var colorsEl = $('#psp-pb-colors');
      function renderColors() { colorsEl.innerHTML = ''; COLORS.forEach(function (c) { var has = pbSel[c.name] && pbSel[c.name].qty > 0; var d = document.createElement('div'); d.className = 'psp-pbc' + (has ? ' has' : ''); d.innerHTML = '<span class="qb">' + (has ? pbSel[c.name].qty : '') + '</span><img loading="lazy" src="' + c.img + '" alt="' + esc(c.name) + '"><span class="add">+</span><div class="nm">' + esc(c.name) + '</div>'; d.onclick = function () { pbAdd(c.name); }; colorsEl.appendChild(d); }); }
      function pbAdd(name) {
        /* hard cap: refuse the add and pulse the "maximum reached" notice */
        if (MAXQ && count() >= MAXQ) {
          var p = $('#psp-pb-perk');
          if (p) { p.classList.remove('pulse'); void p.offsetWidth; p.classList.add('pulse'); }
          return;
        }
        if (!pbSel[name]) pbSel[name] = { qty: 0, size: pbSize };
        pbSel[name].qty++; renderColors(); renderRecap();
      }
      window.pspPbDec = function (name) { if (!pbSel[name]) return; pbSel[name].qty--; if (pbSel[name].qty <= 0) delete pbSel[name]; renderColors(); renderRecap(); };
      window.pspPbInc = function (name) { pbAdd(name); };
      window.pspPbSize = function (name, s) { if (pbSel[name]) { pbSel[name].size = s; renderRecap(); } };
      function count() { var n = 0; for (var k in pbSel) n += pbSel[k].qty; return n; }
      function renderRecap() {
        var q = count();
        var d = (MODE === 'fixed') ? null : disc(q);
        var was = UNIT * q, total, showWas, ppuCents;
        if (MODE === 'fixed') { total = fixedTotal(q); ppuCents = q ? total / q : 0; showWas = total < was; }
        else { total = Math.round(UNIT * q * (1 - d.pct / 100)); ppuCents = q ? total / q : 0; showWas = !!d.pct; }
        var giftUnlocked = GIFT_ON && q >= giftFrom;
        $('#psp-pb-count').textContent = q;
        /* fixed mode: literal-deal copy, by priority (offers stack — no floor price) —
           1. adding 1 costs nothing -> "next one is FREE"
           2. adding 1 unlocks more free items -> "Add 1 more — get N FREE"
           3. this pack already contains N free items */
        var perkFx = '';
        if (MODE === 'fixed' && q >= 1) {
          var fNow = freeCount(q), fNext = freeCount(q + 1), nextDelta = fixedTotal(q + 1) - fixedTotal(q);
          if (nextDelta <= 0) perkFx = (__dePOMME ? 'Dein nächster Artikel ist GRATIS — füge noch 1 hinzu' : 'Your next one is FREE — add 1 more');
          else if (fNext > fNow) perkFx = (__dePOMME ? ('Noch 1 dazu — ' + fNext + ' GRATIS-Artikel') : ('Add 1 more — get ' + fNext + ' FREE'));
          else if (fNow >= 1) perkFx = (__dePOMME ? (fNow + ' GRATIS-Artikel im Pack + Versand') : (fNow + ' FREE item' + (fNow > 1 ? 's' : '') + ' in this pack + free shipping'));
        }
        $('#psp-pb-perk').textContent = q >= 2 ? ((MODE === 'fixed') ? (perkFx || ((__dePOMME ? 'Pack-Preis aktiv' : 'Pack price applied') + (giftUnlocked ? (__dePOMME ? ' + Gratis-Geschenk' : ' + free gift') : '') + (__dePOMME ? ' + Versand' : ' + shipping'))) : discLabel(d)) : (q === 1 ? (perkFx || (__dePOMME ? 'Noch 1 für kostenlosen Versand' : 'Add 1 more for free shipping')) : (__dePOMME ? 'Füge 2 für kostenlosen Versand hinzu' : 'Add 2 for free shipping'));
        /* builder cap state: notice + dimmed "+" affordances while at/over the max */
        var atMax = !!(MAXQ && q >= MAXQ);
        var perkEl = $('#psp-pb-perk');
        if (atMax) perkEl.textContent = maxMsg();
        perkEl.classList.toggle('psp-perk--max', atMax);
        if (pbMask) pbMask.classList.toggle('psp-pb--max', atMax);
        $('#psp-pb-fill').style.width = Math.min(q / (barMaxFx || maxMin), 1) * 100 + '%';
        $('#psp-pb-ppu').innerHTML = q ? ('<b>' + money(ppuCents) + '</b>' + (__dePOMME ? '/Stück' : '/item') + (showWas ? ' <s>' + money(UNIT) + '</s>' : '')) : '';
        var byName = {}; COLORS.forEach(function (c) { byName[c.name] = c; });
        var html = '';
        for (var k in pbSel) { (function (name) { var it = pbSel[name]; var szs = SIZES2.map(function (s) { var dis = !avail(name, s); return '<button class="' + (it.size === s ? 'on' : '') + '"' + (dis ? ' disabled' : '') + ' onclick="pspPbSize(\'' + name.replace(/'/g, "\\'") + '\',\'' + s + '\')">' + s + '</button>'; }).join(''); html += '<div class="psp-it"><img loading="lazy" src="' + byName[name].img + '" alt=""><span class="nm">' + esc(name) + '</span><div class="szs">' + szs + '</div><div class="qty"><button onclick="pspPbDec(\'' + name.replace(/'/g, "\\'") + '\')">−</button><span>' + it.qty + '</span><button onclick="pspPbInc(\'' + name.replace(/'/g, "\\'") + '\')">+</button></div></div>'; })(k); }
        $('#psp-pb-items').innerHTML = html;
        if (GIFT_ON) {
          var g = $('#psp-pb-gift'); if (g) { if (giftUnlocked) { g.classList.remove('locked'); g.innerHTML = '<span><b>' + esc(PACK.giftName || (__dePOMME ? 'Gratis-Geschenk' : 'Free gift')) + '</b> — ' + (__dePOMME ? 'freigeschaltet!' : 'unlocked!') + (GIFTC.length ? ' <a data-psp-giftchange>' + (__dePOMME ? 'Farbe ändern' : 'Change color') + '</a>' : '') + '</span>'; var ga = $('[data-psp-giftchange]', g); if (ga) ga.onclick = openGift; } else { g.classList.add('locked'); g.innerHTML = '<span><b>' + esc(PACK.giftName || (__dePOMME ? 'Gratis-Geschenk' : 'Free gift')) + '</b> — ' + (__dePOMME ? 'ab ' + giftFrom + ' Artikeln' : 'unlocks at ' + giftFrom + ' items') + '</span>'; } }
          if (giftUnlocked && GIFTC.length && !pkGiftAsked) { pkGiftAsked = true; openGift(); }
        }
        var add = $('#psp-pb-add');
        if (MAXQ && q > MAXQ) { add.disabled = true; add.textContent = maxMsg(); }
        else if (q >= 1) { add.disabled = false; add.innerHTML = (__dePOMME ? q + ' in den Warenkorb' : 'Add ' + q + ' to cart') + '<span class="atc-price">' + money(total) + (showWas ? ' <s>' + money(was) + '</s>' : '') + '</span>'; } else { add.disabled = true; add.textContent = (__dePOMME ? 'Farbe wählen zum Starten' : 'Add a color to start'); }
      }
      $('#psp-pb-add').onclick = function () {
        var items = []; for (var k in pbSel) { var v = variantId(k, pbSel[k].size); if (v) items.push({ id: v, quantity: pbSel[k].qty, properties: { _pack: '1' } }); }
        if (!items.length) return;
        var btn = $('#psp-pb-add'); btn.disabled = true; var prev = btn.innerHTML; btn.textContent = (__dePOMME ? 'Wird hinzugefügt…' : 'Adding…');
        addWithGift(items, count(), function () { closePB(); btn.disabled = false; btn.innerHTML = prev; });
      };
    }

    /* initial render */
    renderTiers(); renderCombos(); renderSizes(); renderAdd();

    /* relocate the size-help block (Size guide + Find my size + "Runs small" note) to UNDER the size selector;
       it lives in a separate buy-box block (with the size modal). Move only the visible .psp-fit (modal stays). */
    (function () {
      var fitBlk = document.querySelector('.psp-fit'), fitSlot = $('#psp-fit-slot');
      if (fitBlk && fitSlot && !fitSlot.contains(fitBlk)) {
        var fpb = fitBlk.closest('.product-block');
        fitSlot.appendChild(fitBlk);
        if (fpb && fpb !== fitSlot.closest('.product-block') && !fpb.querySelector('.psp-fit')) { fpb.style.margin = '0'; fpb.style.padding = '0'; }
      }
    })();
  });
})();
